<template>
  <div class="item-box">
    <div class="title-box flex-c-b">
      <slot name="title"></slot>
    </div>
    <div class="item-content-box clearfix">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ItemBox"
}
</script>

<style lang="scss" scoped>
.item-box{
  width: 100%;
  border: 1px solid #e6ebf5;
  border-radius: 4px 4px 0px 0px;
  background: #fff;
  & + .item-box {
    margin-top: 18px;
  }
  .title-box{
    width: 100%;
    border-bottom: 1px solid #e6ebf5;
    min-height: 48px;
    line-height: 48px;
    padding: 0 12px;
    .el-form-item {
      margin: 0;
    }
  }
  .item-content-box{
    padding: 16px;
  }
}
</style>